import { Observable } from 'rxjs';
import { AuthModel } from '../models/login-model';
import { AuthenticationModel } from '@domain/models/auth.model';

export abstract class AuthRepository {
  abstract login(authModel: AuthModel): Observable<AuthenticationModel>;
  abstract recovery(authModel: AuthModel): Observable<boolean>;
  abstract refreshToken(refreshToken: string): Observable<AuthenticationModel>;
}
